jQuery(document).ready(function ($) {
    $(document).on('click', '.next-step-3-4', function (event) {
        event.preventDefault();
        console.log("clicked");
        const darmChecked = document.querySelectorAll('input[name="beschwerden"]:checked');
        const gelenkChecked = document.querySelectorAll('input[name="gelenke"]:checked');

        let showDarm = false;
        let showGelenk = false;

        darmChecked.forEach(function(cb) {
          const val = cb.value.toLowerCase();
          if (val !== 'keins davon' && val !== 'none of these') {
            showDarm = true;
          }
        });

        gelenkChecked.forEach(function(cb) {
          const val = cb.value.toLowerCase();
          if (val !== 'keins davon' && val !== 'none of these') {
            showGelenk = true;
          }
        });
        
        if (!showDarm && !showGelenk) {
          showDarm = true;
          showGelenk = true;
        }

        const resultDarm = document.getElementById('result-darmwohl');
        const resultGelenk = document.getElementById('result-gelenk');

        if (resultDarm) resultDarm.style.display = showDarm ? 'block' : 'none';
        if (resultGelenk) resultGelenk.style.display = showGelenk ? 'block' : 'none';

    });

    $(document).on('click', '.rt_page_gesundheitscheck .rich-text__buttons a.button', function (event) {
        event.preventDefault();
        $('.rt_page_gesundheitscheck').fadeOut();
        $('.gesundheitscheck-section').fadeIn();
    });
    $(document).on('click', 'a.button.prev-step-1', function (event) {
        event.preventDefault();
        $('.rt_page_gesundheitscheck').fadeIn();
        $('.gesundheitscheck-section').fadeOut();
    });
    $(document).on('click', 'a.button.next-step-1', function (event) {
        event.preventDefault();
        var dein_hundename = $('input#dein_hundename').val();
        if(dein_hundename == ""){
            $('input#dein_hundename').addClass("error_empty");
        }
        else{
            $('.gesundheitscheck-muliple-step h3.title-step span').text(''+dein_hundename+'');
            $('input#dein_hundename').removeClass("error_empty");
            $('.gesundheitscheck-muliple-step .step-2').fadeIn();
            $('.gesundheitscheck-muliple-step .step-1').fadeOut();
        }
    });
    $(document).on('click', '.box-label-select p', function (event) {
        event.preventDefault();
        $('.box-label-select p').removeClass('active');
        $(this).addClass('active');
    });
     $(document).on('click', 'a.button.next-step-2', function (event) {
        event.preventDefault();
        var hundename = $('.box-label-select p.active').text();
        console.log(hundename);
        if(hundename == "2-6 Monate"){
            $('.gesundheitscheck-muliple-step .step-3').fadeIn();
            $('.gesundheitscheck-muliple-step .step-2').fadeOut();
        }
        else{
            $('.gesundheitscheck-muliple-step .step-2-4').fadeIn();
            $('.gesundheitscheck-muliple-step .step-2').fadeOut();
        }
       
    });
    $(document).on('click', 'a.button.prev-step-2', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-1').fadeIn();
        $('.gesundheitscheck-muliple-step .step-2').fadeOut();
    });
    $(document).on('click', 'a.button.prev-step-3', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-2').fadeIn();
        $('.gesundheitscheck-muliple-step .step-3').fadeOut();
    });
    $(document).on('click', 'a.button.prev-step-2-4', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-2-4').fadeOut();
        $('.gesundheitscheck-muliple-step .step-2').fadeIn();
    });
    $(document).on('click', 'a.button.next-step-2-4', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-3-4').fadeIn();
        $('.gesundheitscheck-muliple-step .step-2-4').fadeOut();
    });
    $(document).on('click', 'a.button.prev-step-3-4', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-3-4').fadeOut();
        $('.gesundheitscheck-muliple-step .step-2-4').fadeIn();
    });
    $(document).on('click', 'a.button.next-step-3-4', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-3-4-content').fadeOut();
        $('.gesundheitscheck-muliple-step .step-3-4-loading').fadeIn();
        setTimeout(function() {
            $('.gesundheitscheck-muliple-step .step-3-4-loading').fadeOut();
            $('.gesundheitscheck-muliple-step .step-3-4').hide();
            $('.gesundheitscheck-muliple-step .step-4').fadeIn();
            $('.gesundheitscheck-muliple-step .step-3-4-content').show();
        }, 2000);
    });
    $(document).on('click', 'a.button.prev-step-4', function (event) {
        event.preventDefault();
        $('.gesundheitscheck-muliple-step .step-4').fadeOut();
        $('.gesundheitscheck-muliple-step .step-3-4').fadeIn();
    });
});